/**
 * Copies the heading of each column into `data-label` on the cells under it, after every render
 * of the host: the cards of the narrow layout above show it as their label. Tables without a
 * header row are left alone.
 */
export class TableLabels {
  constructor(host) {
    this.host = host;
    host.addController(this);
  }

  hostUpdated() {
    for (const table of this.host.renderRoot.querySelectorAll('table')) {
      const labels = [...table.querySelectorAll('thead th')].map((th) => th.textContent.trim());
      if (labels.length === 0) {
        continue;
      }
      for (const row of table.querySelectorAll('tbody tr')) {
        let column = 0;
        for (const cell of row.cells) {
          const label = labels[column] ?? '';
          if (cell.dataset.label !== label) {
            cell.dataset.label = label;
          }
          column += cell.colSpan;
        }
      }
    }
  }
}
